import React from "react";
import notificationImg from "../notification.svg";
import searchIcon from "../searchIcon.svg";
import personImg from "../person-img.png";
import { Link } from "react-router-dom";
const person = "Yunus Altıntop";

const Header = () => {
  return (
    <>
      <nav className="nav">
        <ul className="nav-items">
          <li>
            <span>Arge Projesi’ne Hoşgeldin {person}</span>
          </li>
        </ul>
        <ul className="nav-items nav-items__right">
          <li className="nav-items-inner">
            <form action="" className="nav-form">
              <input
                className="form-control mr-2"
                type="search"
                placeholder="Arama yapın..."
                aria-label="Search"
              />
              <img src={searchIcon} alt="" className="search-icon" />
            </form>
          </li>
          <li className="nav-items">
            <Link to="">
              <span className="notification-dot"></span>
              <img src={notificationImg} width={22} height={22} alt="" />
            </Link>
          </li>
          <li className="nav-items dropdown">
            <Link className="dropdown-toggle" to="#">
              <img src={personImg} alt="" className="person-img" />
              Yunus Altıntop
            </Link>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <Link className="dropdown-item" to="#">
                Action
              </Link>
              <Link className="dropdown-item" to="#">
                Another action
              </Link>
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item" to="#">
                Something else here
              </Link>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Header;
